const txteng1 = [
  // [
  //   "мне действительно нужно выучить английский как можно скорее.",
  //   "I really need to learn English as soon as possible",
  // ],
  ["он пытается найти больше времени.", "He tries to find more time"],
  ["он не пытается найти больше времени.", "He doesn't try to find more time"],
  ["он пытается найти больше времени?", "Does He try to find more time?"],
  ["он говорит по-испански.", "He speaks Spanish"],
  ["он не говорит по-испански.", "He doesn't speak Spanish"],
  ["он говорит по-испански?", "Does He speak Spanish?"],
  ["он ходит в школу.", "He goes to school"],
  ["он не ходит в школу.", "He doesn't go to school"],
  ["он ходит в школу?", "Does He go to school?"],
  ["мне нужно это сделать.", "I need to do it"],
  ["мне не нужно это делать.", "I don't need to do it"],
  ["мне нужно это сделать?", "Do I need to do it?"],
  ["ты все помнишь.", "You remember everything"],
  ["ты ничего не помнишь.", "You don't remember anything"],
  ["ты все помнишь?", "Do You remember everything?"],
  ["они поддерживают нас.", "They support us"],
  ["они не поддерживают нас.", "They don't support us"],
  ["они поддерживают нас?", "Do They support us?"],
  ["девушка показала.", "The girl showed"],
  ["девушка не показала.", "The girl didn't show"],
  ["девушка показала?", "Did The girl show?"],
  ["я ушел из дома (покинул).", "I left home"],
  ["я не ушел из дома.", "I didn't leave home"],
  ["я ушел из дома?", "Did I leave home?"],
  ["я часто отдыхаю здесь.", "I often have a rest here"],
  [
    "мне действительно нужно выучить английский как можно скорее.",
    "I really need to learn English as soon as possible",
  ],
  ["я записал это слово", "I wrote this word down"],
  ["я не записал это слово", "I didn't write this word down"],
  ["я записал это слово?", "Did I write this word down?"],
  ["урок начался вовремя", "The lesson began on time"],
  ["урок не начался вовремя", "The lesson didn't begin on time"],
  ["урок начался вовремя?", "Did The lesson begin on time?"],
  ["полиция поймает их", "The police will catch them"],
  ["полиция не поймает их", "The police won't catch them"],
  ["полиция поймает их?", "Will The police catch them?"],
  [
    "студент угадает правильный ответ",
    "The student will guess the correct answer",
  ],
  [
    "студент не угадает правильный ответ",
    "The student won't guess the correct answer",
  ],
  [
    "студент угадает правильный ответ?",
    "Will The student guess the correct answer",
  ],
  ["сколько это будет стоить?", "How much will it cost?"],
  ["сколько это стоит?", "How much does it cost?"],
];

export default txteng1;
